<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Formulaire de création d'un contact depuis la page d'une entreprise
  -- Fichier : CreateContact.vue
  -->

<template>
  <v-row justify="end">
    <v-form
      ref="formCreateContact"
      v-model="validCreateContact"
      lazy-validation
    >
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            dark
            v-bind="attrs"
            v-on="on"
            outlined
            fab
            x-small
            class="mx-3"
          >
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Ajouter un dernier contact</span>
          </v-card-title>
          <v-card-text>
            <v-menu
              ref="menuDateOfContact"
              v-model="menuDateOfContact"
              :close-on-content-click="true"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="lastContact.dateOfContact"
                  label="Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="lastContact.dateOfContact"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
            <v-text-field v-model="lastContact.name" label="Nom"></v-text-field>
            <v-textarea
              outlined
              label="Remarque"
              v-model="lastContact.remarks"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  props: {
    typeEntrepriseId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    menuDateOfContact: false,
    validCreateContact: true,
    date: null,
    dialog: false,
    lastContact: {
      lastContactId: 0,
      dateOfContact: null,
      nom: null
    }
  }),

  created() {
    this.lastContact.entrepriseId = this.typeEntrepriseId
  },

  methods: {
    // Si le formulaire est valide, création du contact
    submit() {
      if (this.$refs.formCreateContact.validate()) {
        NProgress.start()
        store
          .dispatch('lastContact/createLastContact', this.lastContact)
          .then(() => {
            let lastContactClone = JSON.parse(
              JSON.stringify(store.state.lastContact.lastContact)
            )
            this.addNewData(lastContactClone)
            this.$refs.formCreateLastContact.reset()
          })
          .catch(() => {})
        this.dialog = false
        NProgress.done()
      }
    },
    // Ajoute le contact à l'entreprise
    addNewData(data) {
      store
        .dispatch('entreprise/addLastContact', data)
        .then(() => {})
        .catch(() => {})
    }
  }
}
</script>
